import { render, staticRenderFns } from "./oilqualitygauge.vue?vue&type=template&id=4963c0fc&scoped=true"
import script from "./oilqualitygauge.vue?vue&type=script&lang=js"
export * from "./oilqualitygauge.vue?vue&type=script&lang=js"
import style0 from "./oilqualitygauge.vue?vue&type=style&index=0&id=4963c0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4963c0fc",
  null
  
)

export default component.exports